<app-dashboard-sidemenu></app-dashboard-sidemenu>
<div class="main-content d-flex flex-column">
    <app-dashboard-navbar></app-dashboard-navbar>
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- Start -->
    <div class="add-listings-box1">
        <div class="row">
            <div class="col-lg-4 col-md-12 form-group">
                <label>Supplier Name<span class="star_class">*</span></label>
                <p-dropdown #oldSupplierDropdown [filter]="true" filterBy="supplierName" [options]="supplierList"
                    placeholder="Select Supplier Name" optionValue="supplierId" optionLabel="supplierName"
                    class="custom-dd" (onChange)="getSupplierData($event,'old')" [(ngModel)]="oldsupplierid">

                    <option value="" disabled>Select Supplier Name </option>
                </p-dropdown>

            </div>
            <div class="col-lg-4 col-md-12 form-group submit">
                <button type="submit" class="submit_btn" (click)="getassetdata()"
                    style="margin-right: 5px;">Submit</button>
                <button type="button" class="reset_btn" (click)="resetOldSupplier()">Reset</button>
            </div>


            <div *ngIf="isshowform">
                <p-table #dt2 [value]="assetwisedata" [rows]="10" responsiveLayout="scroll"
                    [showCurrentPageReport]="false" currentPageReportTemplate="Showing {first} to
{last} of {totalRecords} entries" [filterDelay]="0"
                    [globalFilterFields]="['businessUnit', 'supplierName','currencyName','packageNumber','orderNumber','jdecode','assetCode']">
                    <ng-template pTemplate="caption">
                        <div class="d-flex align-items-center " style="width: 100%;">

                            <span class="p-input-icon-left d-flex align-items-center">
                                <i class="pi pi-search"></i>
                                <input [(ngModel)]="filterval" (input)="dt2.filterGlobal($event.target.value,
            'contains')" pInputText type="text" placeholder="Global Search">
                                <p-button (click)="reset(dt2)" type="button" class="ml-2" icon="bx bx-reset"></p-button>
                            </span>

                        </div>
                    </ng-template>


                    <ng-template pTemplate="header">
                        <tr>
                            <th>S.No.</th>
                            <th>Action</th>
                            <th>Asset Code</th>
                            <th>Tool Shifted</th>
                            <th>BU</th>
                            <th>Business Unit</th>
                            <th>PO Type</th>
                            <th>PO No.</th>
                            <th>Tool Description</th>
                            <th>Supplier Name</th>
                            <th>Supplier Code</th>
                            <th>Tool Last Used</th>
                            <th>Tool Estimated Life</th>
                            <Th>Last health checkup picture</Th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-tool let-i="rowIndex">
                        <tr class="p-selectable-row">
                            <td>{{i+1}}</td>
                            <td>
                                <ng-container>
                                    <input type="checkbox" [(ngModel)]="tool.selected" style="cursor: pointer;" [disabled]="tool.shiftedDone">
                                </ng-container>
                            </td>
                            <td>{{tool.assetCode ||'-'}}</td>
                            <!-- <td>{{tool.shiftedDone}}</td>
                              -->
                            <td style="text-align: center;">
                                <button pButton pRipple type="button" *ngIf="tool.shiftedDone== true"
                                    [label]="'Shifted'" class="p-button-rounded
                p-button-success status_button" style="font-size:
                12px; padding:
                0.2rem 1rem;"></button>
                                <button pButton pRipple type="button" *ngIf="tool.shiftedDone == false"
                                    [label]="'Pending'" class="p-button-rounded
                status_button pending" style="font-size:
                12px; padding:
                0.2rem 1rem;"></button>
                            </td>
                            <td>{{tool.bu || '-'}}</td>
                            <td>
                                {{tool.businessUnit || '-'}}
                            </td>
                            <td>{{tool.poType || '-'}}</td>
                            <td>
                                <span>{{tool.orderNumber|| '-'}}</span>
                            </td>
                            <td>
                                <span>
                                    {{tool.itemDescription }}
                                </span>
                            </td>
                            <td>
                                <span>
                                    {{tool.supplierName || '-' }}
                                </span>
                            </td>
                            <td> <span>{{tool.jdecode || '-' }}</span></td>

                            <!-- <td>
                <span>
                    {{tool.assetCode }}
                </span>
            </td> -->

                            <td>
                                <span>{{tool.lastProducedMonth || '-'}}</span>
                            </td>

                            <!-- <td><span><a [href]="tool.lrCopyOfTransporters" target="_blank"
                                        [download]="tool.lrCopyOfTransporters">Preview</a></span></td> -->
                            <td>
                                {{tool.estimatedLifeAtPresent || '-'}}
                            </td>
                            <td><span><a [href]="tool.documentUrl" target="_blank"
                                        [download]="tool.documentUrl">Preview</a></span></td>
                            <!-- <td>
                {{tool.rmgOfIdexToNewSuppliers}}
            </td> -->

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5">No data found.</td>
                        </tr>
                    </ng-template>
                </p-table>
                <form [formGroup]="toolshiftingForm" (ngSubmit)="submitForm()">
                    <div class="row">
                        <!-- <div class="col-lg-4 col-md-12 form-group">
                            <label>Asset Code<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="assetcode"
                                placeholder="Enter Asset Code" autocomplete="off" [class.is-invalid]="submitted &&
                        toolshiftingForm.get('assetcode')?.invalid ||
                        toolshiftingForm.get('assetcode')?.invalid &&
                        toolshiftingForm.get('assetcode')?.touched" />
                            <div class="invalid-feedback">Asset Code is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Tool Description<span class="star_class">*</span></label>
                            <textarea class="form-control" type="text" formControlName="Item_Desc"
                                placeholder="Enter Description" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('Item_Desc')?.invalid ||
                        toolshiftingForm.get('Item_Desc')?.invalid &&
                        toolshiftingForm.get('Item_Desc')?.touched"></textarea>
                            <div class="invalid-feedback">
                                Description are Required </div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Supplier Name(Shifting From)<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="SupplierName"
                                placeholder="Enter Supplier Name" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('SupplierName')?.invalid ||
                        toolshiftingForm.get('SupplierName')?.invalid &&
                        toolshiftingForm.get('SupplierName')?.touched" />
                            <div class="invalid-feedback">Supplier Name is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Supplier Address(Shifting From)<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="SupplierAddress"
                                placeholder="Enter Supplier Address" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('SupplierAddress')?.invalid ||
                        toolshiftingForm.get('SupplierAddress')?.invalid &&
                        toolshiftingForm.get('SupplierAddress')?.touched" />
                            <div class="invalid-feedback">Supplier Address is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Tool Last Used<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="toolused"
                                placeholder="Enter Tool Last Used" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('toolused')?.invalid ||
                        toolshiftingForm.get('toolused')?.invalid &&
                        toolshiftingForm.get('toolused')?.touched" />
                            <div class="invalid-feedback">Tool Last Used is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Tool Estimated Life<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="estimatedlife"
                                placeholder="Enter Estimated Life" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('estimatedlife')?.invalid ||
                        toolshiftingForm.get('estimatedlife')?.invalid &&
                        toolshiftingForm.get('estimatedlife')?.touched" />
                            <div class="invalid-feedback">Tool Last Used is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Last Health Checkup Picture<span class="star_class">*</span></label>
                            <span class="form-control">
                                <a *ngIf="assetwisedata && assetwisedata.length > 0 && assetwisedata[0].documentPath"
                                    [href]="assetwisedata[0].documentPath" target="_blank"
                                    [download]="assetwisedata[0]?.documentPath">Preview</a>
                            </span>
                            <div class="invalid-feedback">Tool Picture is Required</div>
                        </div> -->
                        <!-- <img *ngIf="previewUrl" [src]="previewUrl" alt="Image Preview" width="200" /> -->
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Supplier Name (New/Shifting To)<span class="star_class">*</span></label>
                            <p-dropdown [filter]="true" filterBy="supplierName" [options]="supplierList"
                                placeholder="Select Supplier Name" optionValue="supplierId"
                                formControlName="SupplierNamenew" optionLabel="supplierName" class="custom-dd"
                                (onChange)="getSupplierData($event)">

                                <option value="" disabled>Select Supplier Name </option>
                            </p-dropdown>
                            <div class="error" *ngIf="submitted &&
                    toolshiftingForm.get('SupplierNamenew')?.invalid ||
                    toolshiftingForm.get('SupplierNamenew')?.invalid &&
                    toolshiftingForm.get('SupplierNamenew')?.touched">Please
                                select Supplier Name</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Supplier Address(Shifting To)<span class="star_class">*</span></label>
                            <input class="form-control" type="text" formControlName="SupplierAddressnew"
                                placeholder="Enter Supplier Address" autocomplete="off" readonly [class.is-invalid]="submitted &&
                        toolshiftingForm.get('SupplierAddressnew')?.invalid ||
                        toolshiftingForm.get('SupplierAddressnew')?.invalid &&
                        toolshiftingForm.get('SupplierAddressnew')?.touched" />
                            <div class="invalid-feedback">Address Is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Jde Code<span class="star_class">*</span></label>
                            <ng-container>
                                <input type="text" formControlName="Jdecode" placeholder="Jde Code" class="form-control"
                                    readonly [class.is-invalid]="submitted &&
                            toolshiftingForm.get('Jdecode')?.invalid ||
                            toolshiftingForm.get('Jdecode')?.invalid &&
                            toolshiftingForm.get('Jdecode')?.touched" />
                                <div class="invalid-feedback">Jde Code Is Required</div>
                            </ng-container>

                        </div>

                        <div class="col-lg-4 col-md-12 form-group">
                            <label>LR copy of transporter</label>
                            <input class="form-control" type="file" (change)="uploadDoc($event,'lr_copy')"
                                placeholder="Enter PO Number" autocomplete="off" />
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>DC of existing supplier<span class="star_class">*</span></label>
                            <input class="form-control" type="file" (change)="uploadDoc($event,'dc')"
                                placeholder="Enter PO Number" autocomplete="off" [class.is-invalid]="submitted &&
                        toolshiftingForm.get('dc_supplier')?.invalid ||
                        toolshiftingForm.get('dc_supplier')?.invalid &&
                        toolshiftingForm.get('dc_supplier')?.touched" />
                            <div class="invalid-feedback">DC is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>RMG of idex to new supplier <span class="star_class">*</span></label>
                            <input class="form-control" type="file" (change)="uploadDoc($event,'Rmg')"
                                placeholder="Enter PO Number" autocomplete="off" [class.is-invalid]="submitted &&
                        toolshiftingForm.get('rmg_doc')?.invalid ||
                        toolshiftingForm.get('rmg_doc')?.invalid &&
                        toolshiftingForm.get('rmg_doc')?.touched" />
                            <div class="invalid-feedback">Rmg is Required</div>
                        </div>
                        <div class="col-lg-4 col-md-12 form-group">
                            <label>Remarks</label>
                            <textarea class="form-control" type="text" formControlName="remarks"
                                placeholder="Enter remarks" autocomplete="off"></textarea>
                        </div>
                    </div>


                    <div class="form-group">
                        <button type="submit" class="submit_btn">Submit</button>

                    </div>
                </form>
            </div>

        </div>
    </div>

</div>